import { useEffect } from "react";

let openModalCount = 0;

const Modal = ({ className, ...props }) => {
    const modalVisibility = props.open ? "block" : "hidden";

    useEffect(() => {
        if (props.open) {
            openModalCount += 1;
            document.body.style.overflow = "hidden";
        }
        return () => {
            if (props.open) {
                openModalCount -= 1;
                if (openModalCount === 0) {
                    document.body.style.overflow = "";
                }
            }
        };
    }, [props.open]);

    return (
        <div className={`fixed inset-0 p-5 backdrop-blur flex items-center ${modalVisibility}`}>
            <dialog
                {...props}
                className={`max-h-[90vh] overflow-scroll ${className ?? ""}`}
            >
                {props.children}
            </dialog>
        </div>
    );
};

export default Modal;